// angular
// 	.module("HeroPRO")
// 	.controller("PipelineController", PipelineController);

import _ from 'lodash';

import './pipeline.scss';

/* @ngInject */
export default function PipelineController(
    $scope, $rootScope, $q, $state, $stateParams, $filter, PipelineFactory, ProjectAdvanceFactory, UserData, ModalService, hpLoggerService, HPConfig,
    HPProjectAdvance, $analytics, $transitions, $timeout,
) {
    const vm = this;
    let pipelineTableReadyForData;
    let contractorId;
    vm.currentStage = 0;
    vm.PageNumber = 0;
    vm.TotalCount = 0;
    vm.loading = true;
    vm.template = '';
    vm.pipelineStages = PipelineFactory.getPipelineStages();
    vm.currentFilter = [];
    vm.visibilityFilters = PipelineFactory.pipelineVisibilityFilters;
    vm.canDownloadPipelineReport = false;
    vm.downloadPipelineReportUrl = `${HPConfig.heroProApi}Pipeline/SpreadSheet`;
    vm.downloadingPipelineReport = false;

    init();

    /*= ========================================
	 =            Private Functions            =
	 ========================================= */
    function init() {
        pipelineTableReadyForData = $q((resolve) => {
            $scope.$on('pipelineTableReady', resolve);
        });

        $scope.$watch(() => PipelineFactory.pipelineFilterItems, (newVal) => {
            vm.currentFilter = newVal;
        });

        setRoutedPipelineStage();
        vm.template = (vm.currentStage === 1) ? 'pipelineLeadsTable' : 'pipelineTable';

        validateOptions();
        setSelectedVisibilityFilter();

        // Load pipeline data on page load
        UserData.getCurrentLocation().then((data) => {
            contractorId = data.ContractorId;
            getPipelineData();
        });

        UserData.getUserData().then((response) => {
            if (response.HasElevatedAccess === true) {
                vm.canDownloadPipelineReport = true;
            }
        });

        // Update pipeline data when the location dropdown is changed
        $scope.$on('HPLocationChange', (event, data) => {
            contractorId = data.ContractorId;
            PipelineFactory.clearPipelineDataOptions();
            getPipelineData();
        });

        // Update pipeline data when a column header is clicked
        $scope.$on('sortClicked', () => {
            vm.PageNumber = 0;
            getPipelineData();
        });

        // If we're coming from a non-pipeline page, clear ALL pipeline data options
        // $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState) => {
        // 	if (fromState.name !== "pipeline") {
        // 		PipelineFactory.clearPipelineDataOptions();
        // 	}
        // });

        $transitions.onStart({}, (transition) => {
            if (transition.$from().name !== 'pipeline') {
                PipelineFactory.clearPipelineDataOptions();
            }
        });
    }

    function getPipelineData() {
        vm.loading = true;
        if (vm.currentStage === 1) {
            getPipelineLeadData();
        } else {
            getPipelineLoanData();
        }
    }

    function getPipelineLeadData() {
        PipelineFactory.setPipelineDataOptions({
            PipelineStageId: vm.currentStage,
            LocationContractorId: contractorId,
            PageNumber: vm.PageNumber,
            DisplayOption: vm.selectedVisibilityFilter.filterId,
        });

        PipelineFactory.getPipelineLeadData()
            .then((response) => {
                const data = response.data.Data;
                vm.TotalCount = data.TotalCount;
                alertPipelineTable(data.PipelineKBYGs);
                vm.loading = false;
            }, (errResponse) => {
                const loggingPayload = PipelineFactory.getPipelineState();
                _.extend(loggingPayload, { ErrorMessage: errResponse });
                hpLoggerService.error(
                    'Failure retrieving Pipeline Leads from API.', 'PipelineController',
                    'getPipelineLeadData', loggingPayload,
                );
            });
    }

    function getPipelineLoanData() {
        PipelineFactory.setPipelineDataOptions({
            LocationContractorId: contractorId,
            PipelineStageId: vm.currentStage,
            PageNumber: vm.PageNumber,
            DisplayOption: vm.selectedVisibilityFilter.filterId,
        });

        PipelineFactory.getPipelineLoanData()
            .then((response) => {
                const data = response.data.Data;
                getAdvancePaymentData(data);
                getProjectAdvanceData(data);
                vm.TotalCount = data.TotalCount;
                alertPipelineTable(data.PipelineFundingRequests);
                vm.loading = false;
            }, (errResponse) => {
                const loggingPayload = PipelineFactory.getPipelineState();
                _.extend(loggingPayload, { ErrorMessage: errResponse });
                hpLoggerService.error(
                    'Failure retrieving Pipeline Loans from API.', 'PipelineController',
                    'getPipelineLoanData', loggingPayload,
                );
            });
    }

    function setSelectedVisibilityFilter() {
        if (PipelineFactory.getPipelineDataOptions().DisplayOption !== undefined) {
            // If the visibility filter has previously been set, use that value
            vm.selectedVisibilityFilter = _.findWhere(
                PipelineFactory.pipelineVisibilityFilters,
                { filterId: PipelineFactory.getPipelineDataOptions().DisplayOption },
            );
        } else {
            // Otherwise, default to active projects
            vm.selectedVisibilityFilter = vm.visibilityFilters[1];
        }
    }


    function getAdvancePaymentData(fundingRequests) {
        if (fundingRequests.TotalCount !== undefined && fundingRequests.TotalCount > 0) {
            const fundingRequestIds = _.pluck(fundingRequests.PipelineFundingRequests, 'FundingRequestId');

            PipelineFactory.getAdvancePaymentData({ FundingRequestIds: fundingRequestIds }).then((response) => {
                const advancePaymentData = response.data.Data;

                _.each(fundingRequests.PipelineFundingRequests, (fundingRequest) => {
                    fundingRequest.advancePaymentData = advancePaymentData[fundingRequest.FundingRequestId];
                    let description,
                        buttonText = '';
                    let showAdvancePaymentTooltip = false;

                    if (fundingRequest.advancePaymentData.DisbursementStatusId === 1 || fundingRequest.advancePaymentData.DisbursementStatusId === null || fundingRequest.advancePaymentData.DisbursementStatusId === undefined && vm.currentStage !== 5) {
                        // Do not show advance payment tooltips in the closed tab (pipelineStageId === 5)
                        description = 'This job is eligible for Advance Payment. Once docs are signed, payment will be sent 5 days after NTP.';
                        buttonText = 'Advance scheduled';
                        showAdvancePaymentTooltip = true;
                    } else if (fundingRequest.advancePaymentData.DisbursementStatusId === 2) {
                        description = $filter('currency')(fundingRequest.advancePaymentData.DisbursementAmount, '$', 2);
                        description += ' Advance Payment sent on ';
                        description += $filter('date')(fundingRequest.advancePaymentData.DisbursementStatusChangedDate, 'shortDate');
                        buttonText = 'Advance sent';
                        showAdvancePaymentTooltip = true;
                    } else if (fundingRequest.advancePaymentData.DisbursementStatusId === 5) {
                        description = $filter('currency')(fundingRequest.advancePaymentData.DisbursementAmount, '$', 2);
                        description += ' Advance Payment invoiced on ';
                        description += $filter('date')(fundingRequest.advancePaymentData.DisbursementStatusChangedDate, 'shortDate');
                        buttonText = 'Advance invoiced';
                        showAdvancePaymentTooltip = true;
                    }

                    fundingRequest.advancePaymentData.tooltipDescription = description;
                    fundingRequest.advancePaymentData.buttonText = buttonText;
                    fundingRequest.advancePaymentData.showAdvancePaymentTooltip = showAdvancePaymentTooltip;
                });

                alertPipelineTable(fundingRequests.PipelineFundingRequests);
            });
        }
    }

    function getProjectAdvanceData(fundingRequests) {
        if (fundingRequests.TotalCount !== undefined && fundingRequests.TotalCount > 0) {
            const fundingRequestIds = _.pluck(fundingRequests.PipelineFundingRequests, 'FundingRequestId');

            ProjectAdvanceFactory.getProjectAdvanceStatus({ FundingRequestIds: fundingRequestIds }).then((response) => {
                const projectAdvanceData = response.data.Data;

                if (projectAdvanceData !== undefined && projectAdvanceData.ProjectAdvanceStatusList !== undefined && projectAdvanceData.ProjectAdvanceStatusList.length > 0) {
                    _.each(fundingRequests.PipelineFundingRequests, (fundingRequest) => {
                        let matchingProjAdvFound = false;
                        _.each(projectAdvanceData.ProjectAdvanceStatusList, (paStatus) => {
                            if (matchingProjAdvFound === false) {
                                if (fundingRequest.FundingRequestId === Number(paStatus.FundingRequestId)) {
                                    matchingProjAdvFound = true;
                                    fundingRequest.projectAdvanceData = paStatus;
                                    processProjectAdvance(fundingRequest);
                                }
                            }
                        });
                    });

                    alertPipelineTable(fundingRequests.PipelineFundingRequests);
                }
            });
        }
    }

    function alertPipelineTable(data) {
        pipelineTableReadyForData.then(() => {
            $scope.$broadcast('pipelineTableUpdate', {
                pipelineStageId: vm.currentStage,
                data,
            });
        });
    }

    // Added function to use stateParams to set the correct currentStage.
    function setRoutedPipelineStage() {
        for (const key in vm.pipelineStages) {
            const stage = vm.pipelineStages[key];
            if (stage.pipelineStageName === $stateParams.stageName) {
                vm.currentStage = stage.pipelineStageId;
            }
        }
        // Default path if stageName does not exist as a pipeline stage.
        if (vm.currentStage === 0) {
            $state.go('pipeline', { stageName: 'leads' });
        }
    }

    // Added function to check if the current stage matches the filterDataOptions stageId.
    // If filter stage and current stage do not match, remove the filter from the PipelineFactory.
    // Added sortoptions.
    function validateOptions() {
        const filterData = PipelineFactory.getPipelineDataOptions();
        if (vm.currentStage !== filterData.PipelineStageId) {
            PipelineFactory.pipelineFilterItems = [];
            PipelineFactory.clearPipelineDataOption('filterOptions');
            PipelineFactory.clearPipelineDataOption('sortOptions');
        }
    }

    function processProjectAdvance(fundingRequest) {
        let paStatusFound = false;
        _.each(HPProjectAdvance, (paConfig, key) => {
            if (paStatusFound === false) {
                if (key === fundingRequest.projectAdvanceData.StatusName) {
                    paStatusFound = true;
                    fundingRequest.projectAdvanceData.template = paConfig.template;
                    fundingRequest.projectAdvanceData.buttonText = paConfig.buttonText;
                    enableProjectAdvanceTooltip(fundingRequest, paConfig);
                }
            }
        });
    }

    function enableProjectAdvanceTooltip(fundingRequest, paConfig) {
        const matchingStage = _.find(paConfig.stages, allowedStage => allowedStage === vm.currentStage);

        if (matchingStage !== undefined && matchingStage !== null) {
            fundingRequest.projectAdvanceData.showProjectAdvanceTooltip = true;
        } else {
            fundingRequest.projectAdvanceData.showProjectAdvanceTooltip = false;
        }
    }

    /* -----  End of Private Functions  ------*/

    /*= =======================================
	 =            Public Functions            =
	 ======================================== */
    vm.switchPage = function (pageNumber) {
        vm.PageNumber = pageNumber - 1;
        getPipelineData();
    };

    vm.switchStage = function (pipelineStage) {
    // (ajt 11/2/2015) - Changed method to receive selected stage JS object. Assign selected Id to currentStage and set state to new selected stage
        vm.currentStage = pipelineStage.pipelineStageId;
        PipelineFactory.pipelineFilterItems = [];
        PipelineFactory.clearPipelineDataOptionsExcept('DisplayOption'); // preserve DisplayOption (visibility filter)
        vm.PageNumber = 0;
        $state.go('pipeline', { stageName: pipelineStage.pipelineStageName });
    };

    vm.displayPipelineFilter = function () {
        ModalService.launchPipelineFilterModal({
            templateUrl: 'app/pipeline/filter/pipelineFilterModal.html',
            windowClass: 'pipeline-filter-modal',
            controller: 'PipelineFilterModalController',
            controllerAs: 'pipelineFilterModal',
        });
    };

    vm.clearPipelineFilter = function () {
        PipelineFactory.pipelineFilterItems = [];
        PipelineFactory.clearPipelineDataOption('filterOptions');
        getPipelineData();
    };

    vm.visibilityFilterSelected = function (filter) {
        vm.selectedVisibilityFilter = filter;
        PipelineFactory.setPipelineDataOptions({
            DisplayOption: filter.filterId,
        });
        vm.PageNumber = 0;
        getPipelineData();
    };

    vm.downloadPipelineReport = function () {
        if (vm.downloadingPipelineReport === false) {
            $analytics.eventTrack('Download Report', { category: 'Pipeline', label: vm.pipelineStages[vm.currentStage - 1].name });
            vm.downloadingPipelineReport = true;
            // Add a delay of 2s so that the spinner appears before the download
            $timeout(() => {
	  			vm.downloadingPipelineReport = false;
            }, 3000);
        }
    };
    /* -----  End of Public Functions  ------*/
}



// WEBPACK FOOTER //
// ./src/app/pipeline/pipelineController.js